import { environmentConfig } from "@src/appV2/environment";

/**
 * Builds an impersonation URL with a worker-specific subdomain so each iframe
 * gets a unique origin, naturally isolating cookies and storage between sessions.
 *
 * Example: `https://hcp.clipboard.health` + workerId `abc123`
 *   → `https://abc123.hcp.clipboard.health/impersonate?username=...`
 */
export function buildImpersonationUrl(workerId: string, cognitoUsername: string): string {
  const baseUrl = new URL(environmentConfig.REACT_APP_WORKER_APP_URL);
  baseUrl.hostname = `${workerId}.${baseUrl.hostname}`;
  baseUrl.pathname = "/impersonate";
  baseUrl.searchParams.set("username", cognitoUsername);
  return baseUrl.toString();
}
